import React from 'react';
import PropTypes from 'prop-types';
import styles from './NativeApp.module.scss';

/**
 * Stands in for Boost, payments and vault surfaces in client mode. Plain
 * text, never a link: pointing to web payments is steering (Apple 3.1.1).
 */
const WebPaymentsNotice = ({ className }) => (
  <p
    className={
      className
        ? `${styles.webPaymentsNotice} ${className}`
        : styles.webPaymentsNotice
    }
  >
    Boosts and payments are managed from your account on twine.net.
  </p>
);

WebPaymentsNotice.propTypes = {
  className: PropTypes.string,
};

export default WebPaymentsNotice;
